import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { RateWithDetails } from '../../../../api/types/lecturers/user-details-lecturer';
import dateUtils from '../../../../utils/date-format';
import RateDetailsDialog from './rate-details-dialog';

interface RatesTableHomePageProps {
  rates: RateWithDetails[];
  onRefresh?: () => Promise<void>;
}

const RatesTableHomePage: React.FC<RatesTableHomePageProps> = ({
  rates,
  onRefresh,
}) => {
  const [selectedRate, setSelectedRate] = useState<RateWithDetails | null>(
    null,
  );
  const [dialogVisible, setDialogVisible] = useState(false);
  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('he-IL', {
      style: 'currency',
      currency: 'ILS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const formatFullName = (rowData: RateWithDetails): string => {
    return `${rowData.firstName || ''} ${rowData.lastName || ''}`.trim();
  };

  const handleRowClick = (rate: RateWithDetails) => {
    setSelectedRate(rate);
    setDialogVisible(true);
  };

  const handleDialogHide = () => {
    setDialogVisible(false);
    setSelectedRate(null);
  };

  const handleRefresh = async () => {
    if (onRefresh) {
      await onRefresh();
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        padding: '20px',
        height: '100%',
        borderRadius: '12px',
      }}
    >
      <style>{`
        .rates-table-clickable .p-datatable-tbody > tr {
          cursor: pointer;
          transition: background-color 0.2s;
        }
        .rates-table-clickable .p-datatable-tbody > tr:hover {
          background-color: #f8fafc !important;
        }
      `}</style>
      <div
        style={{
          paddingBottom: '10px',
          color: '#185FD3',
          fontSize: '18px',
          marginBottom: '16px',
        }}
      >
        תעריפים ({rates.length})
      </div>

      <DataTable
        value={rates}
        emptyMessage={<div style={{ textAlign: 'right' }}>אין תעריפים</div>}
        scrollHeight="200px"
        scrollable
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
        }}
        onRowClick={(e) => handleRowClick(e.data as RateWithDetails)}
        rowClassName={() => 'p-datatable-row-clickable'}
        className="rates-table-clickable"
      >
        <Column
          field="fullName"
          header="שם"
          style={{ textAlign: 'right', fontSize: '14px' }}
          headerStyle={{
            textAlign: 'right',
            fontSize: '14px',
            fontWeight: 'bold',
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: RateWithDetails) => (
            <div
              style={{ fontSize: '13px' }}
            >{`${rowData.firstName} ${rowData.lastName}`}</div>
          )}
        />

        <Column
          field="nationalId"
          header="ת.ז"
          style={{ textAlign: 'right', fontSize: '14px' }}
          headerStyle={{
            textAlign: 'right',
            fontSize: '14px',
            fontWeight: 'bold',
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: RateWithDetails) => (
            <div style={{ fontSize: '13px' }}>
              {rowData.nationalId || 'לא צוין'}
            </div>
          )}
        />

        <Column
          field="rate"
          header="סכום"
          style={{ textAlign: 'right', fontSize: '14px' }}
          headerStyle={{
            textAlign: 'right',
            fontSize: '14px',
            fontWeight: 'bold',
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: RateWithDetails) => (
            <div style={{ fontSize: '13px', fontWeight: '500' }}>
              {formatCurrency(rowData.rate)}
            </div>
          )}
        />

        <Column
          field="createdAt"
          header="תאריך יצירה"
          style={{ textAlign: 'right', fontSize: '14px' }}
          headerStyle={{
            textAlign: 'right',
            fontSize: '14px',
            fontWeight: 'bold',
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: RateWithDetails) => (
            <div style={{ fontSize: '13px' }}>
              {dateUtils.displayFormatDate(rowData.createdAt)}
            </div>
          )}
        />
      </DataTable>

      <RateDetailsDialog
        visible={dialogVisible}
        onHide={handleDialogHide}
        rateWithDetails={selectedRate}
        onRefresh={handleRefresh}
      />
    </div>
  );
};

export default RatesTableHomePage;
